import { DropdownButton } from './DropdownButton';

// TODO: in v9, move styled() from DropdownButton.jsx to here
export var StyledDropdownButton = DropdownButton;